import React, { Component } from "react";

class Footer extends Component {
  state = {
    openMenu: "arquivos",
    openSubMenu: "",
    showFooter: false
  };

  toggleMenu = (menu) => {
    this.setState((prevState) => ({
      openMenu: prevState.openMenu === menu ? "" : menu,
      openSubMenu: ""
    }));
  };

  toggleSubMenu = (submenu) => {
    this.setState((prevState) => ({
      openSubMenu: prevState.openSubMenu === submenu ? "" : submenu
    }));
  };

  toggleFooter = () => {
    this.setState((prevState) => ({ showFooter: !prevState.showFooter }));
  };

  render() {
    const { openMenu, openSubMenu, showFooter } = this.state;

    const menus = [
        {
            key: "arquivos", 
            label: "ARQUIVOS", 
            submenus: [
                { label: "IDENTIDADE VISUAL", url: "/identidade-visual" },
                { label: "LOGOS CLIENTES", url: "/logos-clientes" },
                { label: "APRESENTAÇÕES", url: "/presentaciones" },
                { label: "CASES", url: "/cases" },
            ]
        },
        {
            key: "BENEFICIOS", 
            label: "BENEFICIOS", 
            submenus: [
                { label: "Saúde", url: "/saude" },
                { label: "Vida", url: "/vida" },
                { key: "Outros", 
                    label: "Outros", 
                    submenus: [
                        { label: "Academia", url: "/convenios-academia" },
                        { label: "DayOff", url: "/day-off" },
                        { label: "Educação", url: "/educacion" },
                        { label: "Parcerias", url: "/parcerias" },
                        { label: "restaurantes", url: "/restaurantes" }
                    ]
                }
            ]
        },
        {
            key: "DIRETRIZES", 
            label: "DIRETRIZES", 
            submenus: [
                { label: "Calendario Oficial", url: "calendario-oficial" },
                { key: "Politicas", 
                    label: "Politicas", 
                    submenus: [
                        { label: "Administrativo", url: "/politicas-administrativo" },
                        { label: "Financeiro", url: "/politicas-financeiro" },
                        { label: "RH", url: "/politicas-rh" },
                        { label: "TI", url: "/politicas-ti" },
                        { label: "IPG", url: "/ipg" }
                    ]
                },
                { key: "Procedimentos", 
                    label: "Procedimentos", 
                    submenus: [
                        { label: "Administrativo", url: "/procedimientos-administrativo" },
                        { label: "Financeiro", url: "/procedimientos-financeiro" },
                        { label: "RH", url: "/procedimientos-rh" },
                        { label: "TI", url: "/procedimientos-ti" },
                        { label: "Comunicação Corporativa", url: "/c-corporativa" }
                    ]
                },
                { label: "Saúde e Segurança", url: "saude-seguran" },
                { key: "FAQ", 
                    label: "FAQ", 
                    submenus: [
                        { label: "Financeiro", url: "/faq_financeiro" },
                    ]
                },
            ]
        },
        {
            key: "FERRAMENTAS", 
            label: "FERRAMENTAS", 
            submenus: [
                { label: "Entendam cada uma", url: "/entendam-cada-uma" },
                { label: "Mídia Programática", url: "https://programmatic.wmccann.com/" },
                { key: "Estratégia", 
                    label: "Estratégia", 
                    submenus: [
                        { label: "Truth to meaning", url: "https://truth2meaning.wmccann.com/" },
                    ]
                },
                { key: "FAQFerramentas", 
                    label: "FAQFerramentas", 
                    submenus: [
                        { label: "FAQ Suporte", url: "/faq_suporte" },
                        { label: "FAQ Skills", url: "/faq_skills" },
                        { label: "FAQ AdSolutions", url: "/faq_adsolutions" },
                    ]
                }
            ]
        },
        {
            key: "NOTÍCIAS", 
            label: "NOTÍCIAS", 
            submenus: [
                { label: "Comunicação Interna", url: "/comunicacao-interna" },
                { label: "Comunicação Externa", url: "/comunicacao-externa" },
                { key: "Internacional", 
                    label: "Internacional", 
                    submenus: [
                        { label: "INSIDE LATAM", url: "https://interpublic.sharepoint.com/sites/MWG-InsideLatam_PORT" },
                        { label: "INSIDE WG", url: "https://inside.mccannwg.com/" },
                        { label: "INSIDE INTERPUBLIC", url: "https://inside.interpublic.com/" },
                    ]
                }
            ]
        },
        {
            key: "PESSOAS", 
            label: "PESSOAS", 
            submenus: [
                { label: "Diversidade e Inclusão", url: "/diversidad" },
                { label: "Interpublic Alert Line", url: "https://intranet.wmccann.com/wp-content/uploads/2020/04/Fala-que-nos-te-escutamos-IPG_2.pdf" },
                { label: "Perfomance Coaching", url: "https://mwtransitions-redcarpet.silkroad.com/pl" },
                { label: "Portal do Colaborador", url: "https://adp.interpublic.com/" },
                { label: "Treinamentos", url: "pessoas-treinamento" },
                { label: "Vagas", url: "https://mccannwg.avature.net/en_US/careersinternal" },
            ]
        },


      
    ];

    return (
      <div className="container">
        <hr id="hr-foot" className="hrb" />
        <div className="row">
            <div className="col-md-6 cursor-pointer pie" onClick={this.toggleFooter}>
                <span className={` ${showFooter === true ? "mapadosite" : ""}`}>MAPA DO SITE</span>
            </div>
            <div className="col-md-6 end redes" >
                <div className="social-icons">
                    <a href="https://pt-br.facebook.com/WMcCannBR/" target="_blank" className="fab fa-facebook-f"></a>
                    <a href="https://twitter.com/wmccannbr" className="fab fa-x-twitter" target="_blank"></a>
                    <a href="https://www.instagram.com/wmccannbr/" className="fab fa-instagram" target="_blank"></a>
                    <a href="https://www.linkedin.com/company/wmccann/?viewAsMember=true" target="_blank" className="fab fa-linkedin-in"></a>
                    <a href="https://www.tiktok.com/@wmccannbrasil" className="fab fa-tiktok" target="_blank"></a>
                </div>
            </div>
        </div>
        <br/>
       
        {showFooter && (
          <div className="bg-black footer">
            {menus.map((menu) => (
              <div key={menu.key}>
                <div
                  className={`cursor-pointer font-bold ${openMenu === menu.key ? "underline" : ""}`}
                  onClick={() => this.toggleMenu(menu.key)}
                >
                  {menu.label} {openMenu === menu.key ? "↓" : "→"}
                </div>
                {openMenu === menu.key && (
                  <div>
                    {menu.submenus.map((submenu, index) => (
                      <div key={index}>
                        {typeof submenu === "object" && submenu.submenus ? (
                          <div>
                            <div
                              className="cursor-pointer"
                              onClick={() => this.toggleSubMenu(submenu.key)}
                            >
                              {submenu.label} {openSubMenu === submenu.key ? "↓" : "→"}
                            </div>
                            {openSubMenu === submenu.key && (
                              <div>
                                {submenu.submenus.map((item, subIndex) => (
                                  <div key={subIndex}>
                                    <a href={item.url} className="">{item.label}</a>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div>
                            <a href={submenu.url} className="white">{submenu.label}</a>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default Footer;
